import { render } from "./lessonDetail.vue?vue&type=template&id=3c8aaaf4&scoped=true"
import script from "./lessonDetail.vue?vue&type=script&lang=js"
export * from "./lessonDetail.vue?vue&type=script&lang=js"

import "./lessonDetail.vue?vue&type=style&index=0&id=3c8aaaf4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8aaaf4"]])

export default __exports__